import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SetupCategories from '../components/SetupCategories';

const CategoriesBridge = react2angular(SetupCategories);
export default CategoriesBridge;
